import { render, staticRenderFns } from "./AutoMessages.vue?vue&type=template&id=2b5c000a&scoped=true&"
import script from "./AutoMessages.vue?vue&type=script&lang=js&"
export * from "./AutoMessages.vue?vue&type=script&lang=js&"
import style0 from "./AutoMessages.vue?vue&type=style&index=0&id=2b5c000a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5c000a",
  null
  
)

export default component.exports